import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  type AccountStatusUpdateRequestBody,
  type AccountStatusUpdateResponse,
  updateAccountStatus,
} from '~/services/LuxLoyalty';

import { accountChangeLogQueryKeys } from './accountChangeLogQueryKeys';
import { loyaltyAccountQueryKeys } from './useGetLoyaltyAccount';

interface UseUpdateAccountStatusOptions {
  onSuccess?: (data: AccountStatusUpdateResponse) => void;
  onError?: (error: Error) => void;
}

/** Close or re-open a Société account. */
export function useUpdateAccountStatus(options: UseUpdateAccountStatusOptions = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ customerId, ...body }: AccountStatusUpdateRequestBody & { customerId: string }) =>
      updateAccountStatus(customerId, body),
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: loyaltyAccountQueryKeys.byCustomer(variables.customerId) });
      void queryClient.invalidateQueries({ queryKey: accountChangeLogQueryKeys.byCustomer(variables.customerId) });
      options.onSuccess?.(data);
    },
    onError: options.onError,
  });
}
